import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function EditSolid({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-5 -5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <path
          className={theme.fill}
          d="M29.1582 7.01173333c.64-.64.64-1.674 0-2.314l-3.8406667-3.84c-.64-.64-1.6733333-.64-2.3133333 0L20.0008667 3.8604l6.154 6.1546667L29.1582 7.01173333zM.09353333 23.7677333v6.154H6.2482l18.1506667-18.1506666-6.154-6.15400003L.09353333 23.7677333z"
        />
      </g>
    </svg>
  )
}

EditSolid.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
